import { lazy } from 'react';

const DataTable = lazy(() => import('./DataTable'));

export default DataTable;
